<script>
import FormElement from '@wielink-application/shared/vue/components/form/horizontal/file.vue'

export default FormElement;
</script>